import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FC } from "react";
import * as s from "./styles";
import { SectionToggleButtonProps } from "./types";

export const SectionToggleButton: FC<SectionToggleButtonProps> = ({
  label,
  isExpanded,
  onClick
}: SectionToggleButtonProps) => {
  return (
    <s.ToggleButton
      color={"inherit"}
      endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      fullWidth={true}
      onClick={onClick}
      size={"small"}
      variant={"outlined"}
    >
      {label}
    </s.ToggleButton>
  );
};
